import React from 'react';

import { Title, ButtonsGroup, Button } from 'components/commons';
import { Form, Field } from 'components/form-validation';
import { reasonSchema } from 'validation-schemas/direto';
import { getObjectAsList } from 'utils/utils';
import AtomicDropdown from 'components/AtomicDropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { LoanApplication } from 'generated/graphql';
import { Reason } from 'enums/enums';
import { getFieldOrder } from 'configs/routes';
import useOptimizeConfig from 'components/optimize/optimize-hook';
import { IStepInfo } from 'providers/profile.config';

type ReasonLayoutProps = {
    initialValue: LoanApplication;
    stepInfo: IStepInfo;
    onSubmit(loanApplication: LoanApplication): void;
    onBack(): void;
};

const ReasonLayout: React.FC<ReasonLayoutProps> = ({
    initialValue,
    stepInfo: { title },
    onSubmit,
    onBack,
}) => {
    const { componentVisibility } = useOptimizeConfig();

    const components = getFieldOrder(
        [
            {
                id: 'reason',
                render: (key: number) => (
                    <div className="field-group half" key={key}>
                        <Field
                            component={AtomicDropdown}
                            options={getObjectAsList(Reason)}
                            name="reason"
                            id="money_use"
                        />
                    </div>
                ),
            },
            {
                id: 'reasonDetail',
                render: (key: number) => (
                    <div
                        className="field-group"
                        key={key}
                        hidden={!componentVisibility.loanReasonDescription}
                    >
                        <label>
                            Explique melhor abaixo para{' '}
                            <br className="d-block d-sm-none" />
                            aumentar suas chances
                        </label>
                        <Field
                            autoResize={true}
                            className="w-100 bizcap-textarea"
                            component={InputTextarea}
                            name="reasonDetail"
                            id="money_use_detailed"
                        />
                        <div className="text-area-info">Campo opcional</div>
                    </div>
                ),
            },
        ],
        'ReasonForLoan'
    );

    return (
        <div className="screen reason-for-loan-screen">
            <Form
                schema={reasonSchema}
                initialValues={initialValue}
                onSubmit={onSubmit}
                render={({ valid }) => (
                    <>
                        <Title>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: title,
                                }}
                            />
                        </Title>

                        {components.map((comp, index) => comp.render(index))}

                        <ButtonsGroup>
                            <Button
                                label="voltar"
                                variant="secondary"
                                onClick={onBack}
                                data-category="Navegação Direto"
                                data-action="Clique Voltar"
                                data-label="Voltar /pedido/motivo"
                            />
                            <Button
                                label="continuar"
                                disabled={!valid}
                                type="submit"
                            />
                        </ButtonsGroup>
                    </>
                )}
            />
        </div>
    );
};

export default ReasonLayout;
